var emailExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var phoneExp = /^\d{3}-\d{3,4}-\d{4}$/;
var phoneExp2 = /^\d{2,3}-\d{3,4}-\d{4}$/;
export var isEmail = function isEmail(email) {
  return emailExp.test(email);
};
export var isPhone = function isPhone(phone) {
  return phoneExp.test(phone) || phoneExp2.test(phone);
};